<template>
  <v-dialog v-model="visible" max-width="550" persistent>
    <v-card>
      <v-card-title class="text-h6"> Ny art</v-card-title>

      <v-card-text>
        <v-text-field
          label="Artens namn"
          clearable
          hide-details="true"
          outlined
          v-model="title"
        ></v-text-field>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text :to="{ name: 'ArterList' }"> Avbryt </v-btn>
        <v-btn color="primary" :disabled="!title" :loading="loading" @click="onSave"> Spara </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'ArtCreate',
  props: {},
  data() {
    return {
      visible: true,
      title: '',
      loading: false,
    }
  },
  methods: {
    ...mapActions('arter', { getArter: 'readCollection', createArt: 'create' }),
    async onSave() {
      this.loading = true
      const { id } = await this.createArt({ name_sve: this.title })
      this.loading = false
      this.$router.replace({ name: 'art-info-general', params: { id } })
    },
  },
}
</script>

<style lang="scss" scoped></style>
